import { starterOfferDue } from '../../services/prompts.js';
import type { FeatureManifest } from '../registry.js';

/** MO-03/06 store (SCR-15), the Starter Pack offer (OVL-06), purchases, parental block. */
export default {
  id: 'store',
  flag: 'store',
  online: true,
  art: ['store', 'pip_extra'],
  provides: ['store', 'starterOffer', 'spendConfirm', 'purchaseDone'],
  // the offer opens once the first shop is complete (the server starts its 72 hours then)
  mapOrder: 30,
  mapDue: (a) => a.services.sync.status !== 'offline' && starterOfferDue(a.services.store.state, Number.MAX_SAFE_INTEGER, a.services.now()),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
